<template>
    <div class="container-fluid w-100 h-100 pb-3" style="overflow-x: hidden">
        <navbar :title="$t('work_time.title')" class="mb-1"/>
        <div class="col-sm-12 transparent-bg mt-2" style="overflow: hidden">
            <!-- Tabs Navigation -->
            <ul class="nav nav-tabs routa-tabs">
                <li class="nav-item">
                    <button class="routa-tab" :class="{ active: tabIndex === 0 }" @click="tabIndex = 0">
                        {{ $t('work_time.reports') }}
                    </button>
                     </li>
                <li class="nav-item">
                    <button class="routa-tab" :class="{ active: tabIndex === 1 }" @click="tabIndex = 1">
                        {{ $t('menu.daily_allowances') }}
                    </button>
                     </li>
                <li class="nav-item">
                    <button class="routa-tab" :class="{ active: tabIndex === 2 }" @click="tabIndex = 2">
                        {{ $t('menu.meal_allowances') }}
                    </button>
                     </li>
                <li class="nav-item">
                    <button class="routa-tab" :class="{ active: tabIndex === 3 }" @click="tabIndex = 3">
                        {{ $t('menu.work_time_types') }}
                    </button>
                     </li>
                <li class="nav-item">
                    <button class="routa-tab" :class="{ active: tabIndex === 4 }" @click="tabIndex = 4">
                        {{ $t('menu.cost_center') }}
                    </button>
                     </li>
            </ul>

            <!-- Tab Content -->
            <div class="tab-content routa-tab-content">
                <div class="tab-pane fade" :class="{ show: tabIndex === 0, active: tabIndex === 0 }"  style="min-height: 75vh">
                    <work-time-reports :is-observer="hasObserver(user.roles)"/>
                </div>

                <div class="tab-pane fade" :class="{ show: tabIndex === 1, active: tabIndex === 1 }" style="min-height: 75vh">
                    <daily-allowances :is-observer="hasObserver(user.roles)"/>
                </div>

                <div class="tab-pane fade" :class="{ show: tabIndex === 2, active: tabIndex === 2 }" style="min-height: 75vh">
                    <meal-allowances :is-observer="hasObserver(user.roles)"/>
                </div>

                <div class="tab-pane fade" :class="{ show: tabIndex === 3, active: tabIndex === 3 }" style="min-height: 75vh">
                    <work-time-modes :is-observer="hasObserver(user.roles)"/>
                </div>

                <div class="tab-pane fade" :class="{ show: tabIndex === 4, active: tabIndex === 4 }" style="min-height: 75vh">
                    <cost-centers :is-observer="hasObserver(user.roles)"/>
                </div>

            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
  </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import {workManagementHelper} from "@/components/mixins/WorkManagementMixin";
import WorkTimeReports from "@/components/worktime/WorkTimeReports";
import {userHelper} from "@/components/mixins/UserMixin";
import CostCenters from "@/components/costcenter/CostCenters";
import WorkTimeModes from "@/components/worktime/WorkTimeModes";
import DailyAllowances from "@/components/allowances/DailyAllowances";
import MealAllowances from "@/components/allowances/MealAllowances";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'WorkTimeView',
    components: {
        Navbar,
        MealAllowances,
        DailyAllowances,
        WorkTimeModes,
        CostCenters,
        WorkTimeReports,
    },
    mixins: [restApi, workManagementHelper, userHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            loading: false,
            tabIndex: 0,
        }
    },
    methods: {
       linkTabClass(index) {
            if (this.tabIndex === index) {
                return ['tab-title', 'tab-title-active']
            } else {
                return ['tab-title']
            }
        }
    }
}
</script>

<style>
.tab-title {
    font-size: .9em;
    border: none !important;
    margin-right: .5em;
    margin-left: .5em;
    color: #949494 !important;
    font-weight: bold;
}

.tab-title:hover {
    color: #007BFF;
}

.tab-title-active {
    border-bottom: 2px solid #7FC000 !important;
}

.tab-title-text {
    color: #949494 !important;
    font-weight: bold;
}


.tab-title-text-active {
    color: #000000 !important;
    font-weight: bold;
}


.tab-title-cont {
    height: 2.5em !important;
    padding-top: 1em;
    padding-bottom: 1em;
}

.contract-tabs .nav-link {
    display: flex !important;
    justify-content: center;
    align-items: center;
}

.contract-tabs .nav-tabs {
    height: 3em;
    padding-top: .55em;
}

</style>
